export const Hosts = {
    // API_HOST: `http://10.10.0.41:3000/api`,
    API_HOST: `https://app.detectmenow.com/api`,
    MAP_HOST: `https://www.google.com/maps/search/?api=1&query=`
  };
  